module.exports = __webpack_public_path__ + "static/media/vnsgu_logo.e1076c43.png";